import React from "react";
import FlowStepContainer from "./flowStepContainer";
import FlowStepMultiSelect from "./flowStepMultiSelect";
import haircutsImg from "@images/flows/services/haircuts.svg";
import hairExtensionsImg from "@images/flows/services/hair-extensions.svg";
import makeupImg from "@images/flows/services/makeup.svg";
import barberingImg from "@images/flows/services/barbering.svg";
import hairRemovalImg from "@images/flows/services/hair-removal.svg";
import massagesImg from "@images/flows/services/massage.svg";
import tattoosImg from "@images/flows/services/tattoos.svg";
import nailsImg from "@images/flows/services/nail-services.svg";
import injectablesImg from "@images/flows/services/injectables.svg";
import facialsImg from "@images/flows/services/skincare.svg";
import lashesImg from "@images/flows/services/lashes.svg";
import otherImg from "@images/flows/services/other.svg";

export default function FlowStepBusinessServices({ stepNo, totalSteps, forTrial, onDataSubmit }) {
  const onContinue = (value) => {
    onDataSubmit({
      "business-services": value,
    });
  };

  const options = [
    { label: "Haircuts & styling", value: "Haircuts & styling", img: haircutsImg },
    { label: "Facials & skincare", value: "Facials & skincare", img: facialsImg },
    { label: "Nail services", value: "Nail services", img: nailsImg },
    { label: "Lashes & eyebrows", value: "Lashes & eyebrows", img: lashesImg },
    { label: "Massages", value: "Massages", img: massagesImg },
    { label: "Waxing & sugaring", value: "Waxing & sugaring", img: hairRemovalImg },
    { label: "Injectables & fillers", value: "Injectables & fillers", img: injectablesImg },
    { label: "Tattoos & piercings", value: "Tattoos & piercings", img: tattoosImg },
    { label: "Makeup", value: "Makeup", img: makeupImg },
    { label: "Barbering", value: "Barbering", img: barberingImg },
    { label: "Hair extensions", value: "Hair extensions", img: hairExtensionsImg },
    { label: "Other", value: "Other", img: otherImg },
  ];

  return (
    <FlowStepContainer
      overrideStepLabel={forTrial ? null : "Live 30-Min Demo. 7 Days a Week."}
      stepNo={stepNo}
      totalSteps={totalSteps}
      title={forTrial ? "Which services do you offer?" : "Talk to one of our product experts"}
      subTitle={
        forTrial ? "We'll customize your account with sample data to play with." : "What services do you offer? "
      }
    >
      <FlowStepMultiSelect onContinue={onContinue} options={options} />
    </FlowStepContainer>
  );
}
